module.exports = __webpack_public_path__ + "static/amazing-thailand-acec8a35376496c0c4a3678cd754e8d4.svg";